export default "__VITE_PUBLIC_ASSET__fe2f3835__"